import React, { useState, useEffect } from "react";
import { Container, FormGroup, Label, Modal, ModalBody, ModalFooter, ModalHeader, Input, Col } from 'reactstrap';
import { Formik, Form, FieldArray } from "formik";
import { Loading } from '../../share/loading'
import * as Yup from 'yup'
import '../../share/form.css';
import Swal from 'sweetalert2'
import '../../SupportSystem/Reports/reportall.css';
// import { format } from "date-fns";
import { NumberWithCommmas2 } from "../../share/NumberWithCommmas2";
import * as XLSX from "xlsx";



export function NewReportAllocatedAndSubsidies40Component() {
    const [data, setData] = useState([]);
    const [selectSupport, setSelectSupport] = useState([])
    // console.log("selectSupport", selectSupport)
    const [loading, setLoading] = useState(false);
    const user = JSON.parse(localStorage.getItem("userData"));
    const [openModal, setOpenModal] = useState(false);
    const ToggleModal = () => setOpenModal(!openModal);

    useEffect(() => {
        getdatafromview();
    }, []);
    async function getdatafromview() {
        setLoading(true);
        try {
            let res = await fetch("/api/SupportAllowCate/listAllocated40", {
                method: "POST",
                headers: { 'token': user.token },
            });
            const data = await res.json();
            // console.log("data.dataenum2", data.dataenum);
            setData(data.dataenum);
            setSelectSupport(data.dataenum.filter((v, i, arr) => arr.findIndex(v2 => (v2.supportId === v.supportId)) === i)) //filter เอา id ที่ซ้ำกันออก แล้วเอา array ตัวนี้ไปให้ user เลือก ตอนที่จะกด export
            // setYearData(dataYear.dataenum);
        } catch (e) {
            console.log("err =>" + e);
        } finally {
            setLoading(false);
        }
    }

    // แปลงค่าให้เป็นตัวเลข ถ้าเป็น null/undefined/ว่าง ให้ส่ง "" (cell ว่าง) เพื่อให้ Excel เป็นเลขจริง
    const toNum = (v) => (v === null || v === undefined || v === "" ? "" : Number(v));

    const exportXlsxMerged40 = (rows) => {
        // สร้างหัวตาราง 4 แถว ให้เท่ากับ HTML ที่คุณเขียน
        // รวมทั้งหมด 17 คอลัมน์
        const h0 = [
            "ลำดับ", "เลขที่คำขอ", "วันที่รับคำขอ", "ชื่อผู้ขอรับเงินช่วยเหลือหรืออุดหนุน",
            "ประกาศข้อ 6", "", "", "", "", "", "", "", "", "", "", "", ""
        ];
        const h1 = [
            "", "", "", "",
            "ปี พ.ศ (ปีที่ผ่านมา)",
            "วัน/เดือน/ปี ที่ยื่นแบบแสดงการส่งเงินสมทบ (สท.2) (ปีถัดไป)",
            "สัดส่วนการพัฒนาฝีมือแรงงานที่ผู้ประกอบกิจการดำเนินการ", "", "", "", "", "", "", "",
            "เงินที่ขอรับ (บาท)",
            "เงินที่อนุมัติ (บาท)"
        ];
        const h2 = [
            "", "", "", "",
            "", "", // คอลัมน์ 4-5 ถูก merge ลงมา
            "จำนวนลูกจ้างเฉลี่ยต่อปี (คน)",
            "จำนวนลูกจ้างที่ได้รับการพัฒนาฯ (คน)",
            "ร้อยละของจำนวนลูกจ้างที่ได้รับการพัฒนาฯ (คน)",
            "จำนวนลูกจ้างดำเนินการการพัฒนาฯ", "",  // ครอบ 9-10
            "จำนวนลูกจ้างที่ดำเนินการพัฒนาฯ", "",  // ครอบ 11-12
            "จำนวนเงินช่วยเหลือหรืออุดหนุน", "",    // ครอบ 13-14
            "", "" // 15-16 ถูก merge จากแถวบน
        ];
        const h3 = [
            "", "", "", "",
            "", "", // 4-5
            "", "", "", // 6-8
            "ร้อยละ 70 (คน)", "ร้อยละ 80 (คน)",                  // 9-10
            "ส่วนที่เกินกว่า ร้อยละ 70 (คน)", "ส่วนที่เกินกว่า ร้อยละ 80 (คน)", // 11-12
            "ส่วนที่เกินกว่า ร้อยละ 70 (200 บาท/คน)", "ส่วนที่เกินกว่า ร้อยละ 80 (300 บาท/คน)", // 13-14
            "", "" // 15-16 เป็นหัวเงินจากแถวบน
        ];

        const aoa = [h0, h1, h2, h3];

        // เติมข้อมูลตาม 17 คอลัมน์
        rows.forEach((r, idx) => {
            aoa.push([
                idx + 1,                            // 0 ลำดับ
                r.supportNo ?? "-",                 // 1 เลขที่คำขอ
                r.createDate ?? "-",                // 2 วันที่รับคำขอ
                r.supportName ?? "-",               // 3 ชื่อผู้ขอ
                r.receiveYear ?? "-",               // 4 ปีที่ผ่านมา
                "",                                 // 5 วัน/เดือน/ปีที่ยื่นแบบ (ยังไม่มี => เว้นว่าง/จะค่อยเติมภายหลังได้)
                toNum(r.avgMan),                    // 6 จำนวนลูกจ้างเฉลี่ยต่อปี
                toNum(r.spkTrainMan),               // 7 จำนวนลูกจ้างที่ได้รับการพัฒนาฯ
                (r.trainPercent ?? ""),             // 8 ร้อยละ (ถ้าเป็น string มี % ก็ปล่อยเป็น string)
                toNum(r.avg70),                     // 9 ร้อยละ 70 (คน)
                toNum(r.avg80),                     // 10 ร้อยละ 80 (คน)
                toNum(r.cntGt70Lt80),               // 11 ส่วนเกิน >70
                toNum(r.cntGe80),                   // 12 ส่วนเกิน ≥80
                toNum(r.amt70),                     // 13 ส่วนเกิน 70 (200 บาท/คน)
                toNum(r.amt80),                     // 14 ส่วนเกิน 80 (300 บาท/คน)
                r.paymentAmount,             // 15 เงินที่ขอรับ
                r.paymentAmount              // 16 เงินที่อนุมัติ (ตอนนี้เท่ากัน)
            ]);
        });

        const ws = XLSX.utils.aoa_to_sheet(aoa);

        // กำหนดความกว้างคอลัมน์ให้พอดูสวย ๆ
        ws["!cols"] = [
            { wch: 6 },   // 0 ลำดับ
            { wch: 16 },  // 1 เลขที่คำขอ
            { wch: 16 },  // 2 วันที่รับคำขอ
            { wch: 42 },  // 3 ชื่อผู้ขอ
            { wch: 12 },  // 4 ปี พ.ศ.
            { wch: 26 },  // 5 วัน/เดือน/ปี สท.2
            { wch: 18 },  // 6 ลูกจ้างเฉลี่ย
            { wch: 20 },  // 7 ลูกจ้างที่ได้รับการพัฒนาฯ
            { wch: 22 },  // 8 ร้อยละ
            { wch: 16 },  // 9 ร้อยละ70(คน)
            { wch: 16 },  // 10 ร้อยละ80(คน)
            { wch: 22 },  // 11 >70(คน)
            { wch: 22 },  // 12 >80(คน)
            { wch: 26 },  // 13 เงินส่วนเกิน70
            { wch: 28 },  // 14 เงินส่วนเกิน80
            { wch: 18 },  // 15 เงินที่ขอรับ
            { wch: 18 },  // 16 เงินที่อนุมัติ
        ];

        // สร้าง merges ให้ตรงกับ <thead>
        const merges = [];
        // แถว 0: คอลัมน์ 0-3 rowSpan=4
        [0, 1, 2, 3].forEach(c => merges.push({ s: { r: 0, c }, e: { r: 3, c } }));
        // "ประกาศข้อ 6" ครอบ 4..16 ที่แถว 0
        merges.push({ s: { r: 0, c: 4 }, e: { r: 0, c: 16 } });

        // แถว 1:
        //  - คอลัมน์ 4,5,15,16 แนวตั้งลงแถว 3
        [4, 5, 15, 16].forEach(c => merges.push({ s: { r: 1, c }, e: { r: 3, c } }));
        //  - "สัดส่วน..." ครอบ 6..14 แนวนอน
        merges.push({ s: { r: 1, c: 6 }, e: { r: 1, c: 14 } });

        // แถว 2:
        //  - คอลัมน์ 6,7,8 แนวตั้งลงแถว 3
        [6, 7, 8].forEach(c => merges.push({ s: { r: 2, c }, e: { r: 3, c } }));
        //  - กลุ่ม 9..10, 11..12, 13..14 แนวนอน
        merges.push({ s: { r: 2, c: 9 }, e: { r: 2, c: 10 } });
        merges.push({ s: { r: 2, c: 11 }, e: { r: 2, c: 12 } });
        merges.push({ s: { r: 2, c: 13 }, e: { r: 2, c: 14 } });

        ws["!merges"] = merges;

        // เขียนไฟล์
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, "รายงานข้อ6");
        XLSX.writeFile(wb, "แบบขอรับการจัดสรร_ประกาศข้อ6.xlsx");
    };


    const ExportSupport = async (values) => {
        setLoading(true);
        try {
            // 1) supportId ที่ผู้ใช้ติ๊ก
            const picked = (values?.selectExportAr || []).filter(v => v.status);

            const selectedIds = values.selectExportAr
                .filter(x => x.status)
                .map(x => x.supportId);

            if (!selectedIds.length) {
                setLoading(false);
                return;
            }

            // 2) กรองข้อมูลในตารางให้เหลือเฉพาะ supportId ที่เลือก
            const rows = data.filter(d => selectedIds.includes(d.supportId));

            // 3) สร้างไฟล์ Excel (มี merge หัวตาราง)
            exportXlsxMerged40(rows);

            // 7) อัปเดตสถานะหลังบ้าน (ส่ง supportId[])
            let formData = new FormData();
            let supportIdAr = Array.from(new Set(picked.map(p => p.supportId))).filter(Boolean);
            // console.log(supportIdAr)
            supportIdAr.forEach(item => formData.append("supportIds", item))
            const updateRes = await fetch("/api/SupportAllowCate/updateStatusSupportAllocate", {
                method: "POST",
                body: formData

            });
            if (!updateRes.ok) throw new Error("อัปเดตสถานะไม่สำเร็จ");

            await Swal.fire({
                icon: "success",
                title: "ส่งออกสำเร็จ",
                text: "ได้ทำการอัปเดตสถานะเรียบร้อยแล้ว",
                confirmButtonColor: "#0A66C2",
                confirmButtonText: "ตกลง",
            });

            ToggleModal();
            getdatafromview();
        } catch (e) {
            console.log(e);
            Swal.fire({ icon: "error", title: "เกิดข้อผิดพลาดในการส่งออกไฟล์" });
        } finally {
            setLoading(false);
        }
    };

    const initialValues = {
        selectExportAr: selectSupport.map((item) => ({
            supportId: item?.supportId,
            status: false,
        })),
    }
    const validateSchema = Yup.object().shape({

    })


    if (loading) { return <Loading /> }
    return (

        <Container >
            <center>
                <Label
                    for=""
                >
                    แบบขอรับการจัดสรรเงินช่วยเหลือหรืออุดหนุนจากกองทุนพัฒนาฝีมือแรงงาน ประจำปีงบประมาณ พ.ศ.
                    {data != null && data.length > 0 ? (
                        data[0]?.budgetYear
                    ) : (
                        null
                    )}
                </Label>
            </center>
            <center>
                <Label
                    for=""
                >
                    ตามประกาศคณะกรรมการส่งเสริมการพัฒนาฝีมือแรงงาน
                </Label>
            </center>
            <center>
                <Label
                    for=""
                >
                    เรื่อง หลักเกณฑ์การใช้จ่ายเงินเพื่อช่วยเหลือหรืออุดหนุนจากกองทุนพัฒนาฝีมือแรงงาน ลงวันที่ 31 มีนาคม พ.ศ. 2568
                </Label>
            </center>

            <div className="d-flex w-100 align-items-center justify-content-end mb-3">
                <button
                    onClick={ToggleModal}
                    disabled={selectSupport.length === 0 && selectSupport != null && selectSupport != undefined}
                    // onClick={() => {
                    //     window.open(`api/SupportReports/getExeclthirtyeight`, '_blank');


                    // }} download
                    className="btn-green p-2 w-25">Export Excel</button>

            </div>
            <div className="outer-wrapper">
                <div className="table-wrapper">
                    <table>
                        <thead>
                            {/* แถวบนสุด */}
                            <tr>
                                <th rowSpan="4">ลำดับ</th>
                                <th rowSpan="4">เลขที่คำขอ</th>
                                <th rowSpan="4">วันที่รับคำขอ</th>
                                <th rowSpan="4">ชื่อผู้ขอรับเงินช่วยเหลือหรืออุดหนุน</th>
                                {/* กลุ่ม "ประกาศข้อ 6" */}
                                <th colSpan="13">ประกาศข้อ 6</th>

                            </tr>

                            {/* แถวที่ 2 */}
                            <tr>
                                <th rowSpan="4">ปี พ.ศ<br />(ปีที่ผ่านมา)</th>
                                <th rowSpan="4">วัน/เดือน/ปี<br />ที่ยื่นแบบแสดงการส่งเงินสมทบ (สท.2)<br />(ปีถัดไป)</th>

                                <th colSpan="9">สัดส่วนการพัฒนาฝีมือแรงงานที่ผู้ประกอบกิจการดำเนินการ</th>

                                {/* หัวข้อย่อยของคอลัมน์เงิน (กินพื้นที่ถึงแถวล่างสุด) */}
                                <th rowSpan="3">เงินที่ขอรับ<br />(บาท)</th>
                                <th rowSpan="3">เงินที่อนุมัติ<br />(บาท)</th>
                            </tr>

                            {/* แถวที่ 3 */}
                            <tr>
                                <th rowSpan="4">จำนวนลูกจ้างเฉลี่ยต่อปี<br />(คน)</th>
                                <th rowSpan="4">จำนวนลูกจ้างที่ได้รับการพัฒนาฯ<br />(คน)</th>
                                <th rowSpan="4">ร้อยละของจำนวนลูกจ้างที่ได้รับการพัฒนาฯ<br />(คน)</th>

                                <th colSpan="2">จำนวนลูกจ้างดำเนินการการพัฒนาฯ</th>
                                <th colSpan="2">จำนวนลูกจ้างที่ดำเนินการพัฒนาฯ</th>
                                <th colSpan="2">จำนวนเงินช่วยเหลือหรืออุดหนุน</th>
                            </tr>

                            {/* แถวที่ 4 (ใบไม้สุดท้ายของทุกหัวข้อ) */}
                            <tr>
                                <th>ร้อยละ 70<br />(คน)</th>
                                <th>ร้อยละ 80<br />(คน)</th>
                                <th>ส่วนที่เกินกว่า<br />ร้อยละ 70<br />(คน)</th>
                                <th>ส่วนที่เกินกว่า<br />ร้อยละ 80<br />(คน)</th>
                                <th>ส่วนที่เกินกว่า<br />ร้อยละ 70<br />(200 บาท/คน)<br /></th>
                                <th>ส่วนที่เกินกว่า<br />ร้อยละ 80<br />(300 บาท/คน)<br /></th>
                            </tr>
                        </thead>


                        <tbody>
                            {data?.length > 0 ? (
                                <>
                                    {data?.map((item, i) => (
                                        <tr key={i}>
                                            <td className="text-end">{i + 1}</td>
                                            <td className="text-end">{item.supportNo ?? "-"}</td>
                                            <td className="text-start">{item.createDate ?? "-"}</td>
                                            <td className="text-start">{item.supportName ?? "-"}</td>

                                            <td className="text-end">{item.receiveYear ?? "-"}</td>
                                            <td className="text-center">{"-"}</td>
                                            <td className="text-end">{NumberWithCommmas2(item.avgMan) ?? "-"}</td>
                                            <td className="text-end">{NumberWithCommmas2(item.spkTrainMan) ?? "-"}</td>
                                            <td className="text-end">{item.trainPercent ?? "-"}</td>


                                            {/* ประกาศข้อ 6 */}
                                            <td className="text-end">{NumberWithCommmas2(item.avg70) ?? "-"}</td>
                                            <td className="text-center">{item.avg80 ?? "-"}</td>
                                            <td className="text-end">{NumberWithCommmas2(item.cntGt70Lt80) ?? "-"}</td>
                                            <td className="text-end">{NumberWithCommmas2(item.cntGe80) ?? "-"}</td>
                                            <td className="text-end">{NumberWithCommmas2(item.amt70) ?? "-"}</td>
                                            <td className="text-end">{NumberWithCommmas2(item.amt80) ?? "-"}</td>
                                            {/* <td className="text-center">{item.totalAmt ?? "-"}</td> */}


                                            {/* เงิน */}
                                            <td className="text-end">
                                                {item.paymentAmount}
                                            </td>
                                            <td className="text-end">
                                                {item.paymentAmount}
                                            </td>
                                        </tr>
                                    ))}
                                </>
                            ) : (
                                <tr>
                                    <td className="text-center" colSpan="16">ไม่มีข้อมูล</td>
                                </tr>
                            )}
                        </tbody>

                    </table>
                </div>
            </div>
            <Modal
                isOpen={openModal}
                toggle={ToggleModal}
                backdrop={'static'}
                keyboard={false}
                size="l"
                className="modal-bordered"
                centered
            >
                <Formik
                    initialValues={initialValues}
                    validationSchema={validateSchema}
                    onSubmit={ExportSupport}
                >
                    {({ values, errors, handleChange, handleBlur, setFieldValue, handleSubmit }) => {

                        //va;idate ปุ่ม export ก่อนที่จะ export ข้อมูลจริงๆ
                        const PreExport = () => {
                            let pass = false;
                            console.log(values)
                            values.selectExportAr.forEach(element => {
                                console.log("element", element)
                                if (element.status === true) {
                                    pass = true;
                                    return;
                                }
                            });
                            if (pass === false) {
                                Swal.fire({
                                    icon: "error",
                                    title: "กรุณาเลือกอย่างน้อย 1 รายการ",
                                    html: "",
                                    confirmButtonColor: "#0A66C2",
                                    confirmButtonText: "ตกลง",
                                })
                            } else {
                                Swal.fire({
                                    icon: "info",
                                    title: "ยืนยันการทำรายการหรือไม่ ?",
                                    html: "หากยืนยันการทำรายการแล้ว <br/>จะไม่สามารถเลือกผู้ขอรับเงินช่วยเหลือหรืออุดหนุนเดิมได้",
                                    confirmButtonColor: "#0A66C2",
                                    confirmButtonText: "ตกลง",
                                    showCancelButton: true,
                                    cancelButtonText: "ยกเลิก",
                                    cancelButtonColor: "#ff0000",
                                }).then((result) => {
                                    if (result.isConfirmed) {
                                        handleSubmit(values)
                                    }
                                });
                            }
                        }
                        return (
                            <Form>
                                <ModalHeader toggle={ToggleModal} className="">เลือกชื่อผู้ขอรับเงินช่วยเหลือหรืออุดหนุน</ModalHeader>
                                <ModalBody>
                                    <FieldArray name="selectExportAr">
                                        {(fieldArrayProps) => {
                                            return (
                                                <div className="d-flex flex-column mt-3">
                                                    {selectSupport.length > 0 && selectSupport != null && selectSupport != undefined && selectSupport.map((support, index) => (
                                                        <FormGroup row>
                                                            <Col>
                                                                <Label>
                                                                    <Input
                                                                        type="checkbox"
                                                                        className="cus-type"
                                                                        name={`selectExportAr[${index}].status`}
                                                                        onBlur={handleBlur}
                                                                        onChange={(e) => {
                                                                            handleChange(e)
                                                                            if (e.target.checked) {
                                                                                setFieldValue(e.target.name, true)
                                                                            } else {
                                                                                setFieldValue(e.target.name, false)
                                                                            }
                                                                        }} />
                                                                </Label>
                                                                <span className="ms-3">
                                                                    {support.supportName}
                                                                </span>
                                                            </Col>
                                                        </FormGroup>
                                                    ))}

                                                </div>
                                            )
                                        }}
                                    </FieldArray>
                                </ModalBody>
                                <ModalFooter className="d-flex justify-content-center align-items-center">
                                    <button
                                        disabled={!selectSupport.length}
                                        type="button"
                                        onClick={() => PreExport()}
                                        className="btn-green p-2 w-25">
                                        Export
                                    </button>
                                </ModalFooter>
                            </Form>
                        )
                    }}

                </Formik>

            </Modal>

        </Container>



    )
}